import React, { Component } from 'react';
import { connect } from "react-redux";
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import Notes from 'midi/Notes.js';
import HarmonicsEditor from './HarmonicsEditor.js';
import Dropdown from 'react-dropdown'
import {updateParameter} from 'operations/actions.js';

class OscillatorComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showHarmonics: false,
        };
    }

    showHarmonics(show=true) {
        this.setState({showHarmonics: show});
    }

    getSelectedOscillatorType() {
        return this.props.oscillator.oscillatorType;
    }

    onSelectOscillatorType(o) {
        let value = o.value === 'none' ? undefined : o.value;
        this.props.sequencerEngine.operationManager.dispatch(
            updateParameter(
                this.props.oscillator.oscillatorTypeParameter,
                value));
        this.setState(this.state);
    }


    render() {
        let oscillator = this.props.oscillator;
        let instrument = this.props.instrument;
        if (!oscillator.isInitialized()) {
            return (
                <div></div>
            );
        }

        if (this.state.showHarmonics &&
            oscillator.oscillatorType === 'custom') {
            return (
                <div className="oscillator-component">
                  <div className="clear-fix"/>
                  <HarmonicsEditor oscillator={oscillator}/>
                  <div
                    onClick={() => this.showHarmonics(false)}
                    className="harmonics-button">
                    Done Editing
                  </div>
                </div>
            );
        }
        return (
            <div className="oscillator-component">
              <div className="osc-type-dropdown-container">
                <Dropdown
                  className='osc-type-dropdown'
                  controlClassName='osc-type-control-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={OSCILLATOR_OPTIONS}
                  onChange={(o) => this.onSelectOscillatorType(o)}
                  value={getOscillatorOption(this.getSelectedOscillatorType())}
                  placeholder="Osc. Type" />
              </div>
              <div className="clear-fix"/>
              <EffectParameterSlider
                  automation={this.props.automation}
                  name={'Volume'}
                  parameter={oscillator.oscillatorLevelParameter}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  isParameter={true}
                  min={0}
                  max={1}
                  step={0.01}
                  />
                <EffectParameterSlider
                  automation={this.props.automation}
                  name={'Frequency'}
                  sequencerEngine={this.props.sequencerEngine}
                  parameter={oscillator.oscillatorFrequencyParameter}
                  onParameterChanged={() => instrument.releaseAll()}
                  displayFunction={(x) => Notes.fromTranspose(x).toString()}
                  isParameter={true}
                  min={-32}
                  max={32}
                  step={1}
                  />
                <EffectParameterSlider
                  automation={this.props.automation}
                  name={'Detune'}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  parameter={oscillator.detuneParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={-100}
                  max={100}
                  step={1}
                  />
             <ConditionedComponent condition={oscillator.oscillatorType === 'custom'}>
               <div
                 onClick={() => this.showHarmonics()}
                 className="harmonics-button">Edit Harmonics</div>
             </ConditionedComponent>
           </div>
        );
    }
}

const OSCILLATOR_OPTIONS = [
    {value: 'square', label:'Square'},
    {value: 'sine', label:'Sine'},
    {value: 'triangle', label:'Triangle'},
    {value: 'sawtooth', label:'Sawtooth'},
    {value: 'pwm', label:'PWM'},
    {value: 'pulse', label:'Pulse'},
    {value: 'custom', label:'Custom'},
];

function getOscillatorOption(value) {
    return OSCILLATOR_OPTIONS.filter(
        osc => osc.value === value)[0];
}

const mapStateToProps = (state, props) => {
    return {
            type: props.oscillator.oscillatorType
    };
};

export default connect(mapStateToProps, null)(OscillatorComponent);
